export const getFullName = user => `${user.user_profile?.first_name} ${user.user_profile?.last_name}`;

export const getProfile = keyOrState => {
  if (typeof keyOrState !== 'string') {
    return {
      ...keyOrState.profile,
      user_profile: {
        ...keyOrState.profile.user_profile,
        full_name: getFullName(keyOrState.profile),
      },
    };
  }

  return state => state.profile[keyOrState];
};
